import { SBSummary } from './SBSummary';

export default SBSummary;
